import { render, staticRenderFns } from "./Appellant.vue?vue&type=template&id=7591d073&"
import script from "./Appellant.vue?vue&type=script&lang=js&"
export * from "./Appellant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports